import React from 'react';
import AppBar from "../atoms/AppBar";
import './Awards.css';
import awardsData from '../../Data/jsons/awards.json';

function Awards() {
	// Flatten and transform the data
	// awardsData structure: { "2025": [{ name: "...", imageUrl: "..." }], ... }
	const flattenedAwards = Object.entries(awardsData)
		.sort(([yearA], [yearB]) => Number(yearB) - Number(yearA)) // Sort years descending
		.flatMap(([year, items]) =>
			items.map(item => ({
				...item,
				year,
				// Heuristic: Split name by comma to get title and org if possible
				// Example: "Louis Beecherl Jr. Fellowship, UT Dallas"
				title: item.name.split(',')[0],
				organization: item.name.split(',').slice(1).join(',').trim() || ''
			}))
		);

	return (
		<div className="awards-page">
			<AppBar />

			<div className="awards-main-content">
				<header className="awards-header">
					<div className="hero-text">
						<h1 className="hero-title">Awards</h1>
						<p className="hero-subtitle">
							Recognition of research contributions and academic excellence.
						</p>
					</div>
				</header>

				<section className="awards-list-section">
					<div className="awards-grid">
						{flattenedAwards.map((award, index) => (
							<div key={index} className="award-card">
								<div className="award-header">
									<span className="award-date">{award.year}</span>
									{/* Show organization if extracted, otherwise leaving blank or showing generic */}
									{award.organization && (
										<span className="award-org">{award.organization}</span>
									)}
								</div>

								<div className="award-main">
									<div className="award-title-row">
										{/* Optional: Display Image/Icon if available */}
										{award.imageUrl && (
											<img src={award.imageUrl} alt="" className="award-icon" onError={(e) => e.target.style.display = 'none'} />
										)}
										<h3 className="award-title">{award.title}</h3>
									</div>
								</div>
							</div>
						))}
					</div>
				</section>
			</div>
		</div>
	);
}

export default Awards;